import * as React from "react";
import { Component } from "react";
import { Param } from "../../api/StudyApi";
import { ParamOption, ParamType } from "../../api/GrammarApi";
import arr from "../../util/ArrayDecorator";
import Autocomplete from "../../component/autocomplete/Autocomplete";
import StateDropdown from "../../component/observation/StateDropdown";

interface LabelizeObsParamProps {
  param: Param;
  paramType: ParamType;
  onChange?(param: Param): void;
}

interface LabelizeObsParamState {
  option: ParamOption;
}

export default class LabelizeObsParam extends Component<LabelizeObsParamProps, LabelizeObsParamState> {
  constructor(props: LabelizeObsParamProps) {
    super(props);

    let option;

    if (props.paramType && props.paramType.options) {
      if (props.param && props.param.value) {
        option = arr(props.paramType.options).findFirst((item) => item.code === props.param.value);
      } else if (props.paramType.defaultOpt) {
        option = arr(props.paramType.options).findFirst((item) => item.code === props.paramType.defaultOpt);
      }
    } else {
      console.warn("No ParamType options defined for param", this.props.param);
    }

    if (option && props.param && props.param.state == "proposal") {
      props.param.state = "validated";
      if (!props.param.value) {
        props.param.value = option.code;
      }
    }

    this.state = { option };
  }

  onChangeValue(option?: ParamOption) {
    this.setState({ option });

    const param = this.props.param || { type: this.props.paramType.code };

    // Set state to validated
    if (!param.value && option) {
      param.state = "validated";
    }

    param.value = option ? option.code : null;

    if (!param.state) {
      param.state = "proposal";
    }

    if (this.props.onChange) {
      this.props.onChange(param);
    }
  }

  onChangeState(state: string) {
    const param = this.props.param || { type: this.props.paramType.code };

    if (!param.value && this.state.option) {
      param.value = this.state.option.code;
    }

    param.state = state;

    if (this.props.onChange) {
      this.props.onChange(param);
    }
  }

  render() {
    return (
      <div className="labelize-obs-param">
        <div className="input-group">
          <div className="btn-group" role="group" aria-label="Basic example">
            <Autocomplete
              onChange={(option) => this.onChangeValue(option)}
              placeholder={this.props.paramType ? this.props.paramType.label : ""}
              items={this.props.paramType ? this.props.paramType.options : []}
              toLabel={(item) => item.label}
              value={this.state.option}
            />

            <StateDropdown
              group={true}
              state={this.props.param ? this.props.param.state : "proposal"}
              onChange={this.onChangeState.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }
}
